export default __webpack_public_path__ + "static/media/GT-America-Mono-Bold.e9ff203a.eot";